// Pure payload builders for the V1 email template create and import handlers.
//
// These are field whitelists, so a new field is silently dropped unless it is
// named here. `category` is carried only when the source has one: a brand-new
// template gets no category key, and the read default (Deal) applies. Inventing
// a choice for a template the agent never classified would be wrong (D-02).
import { templateCategory } from '../utils/sendGate.js';

const hasCategory = (source) => !!source && typeof source === 'object'
    && Object.prototype.hasOwnProperty.call(source, 'category');

export function buildCreateTemplatePayload(templateData = {}) {
    const payload = {
        name: (templateData.name || '').trim(),
        subject: templateData.subject || '',
        html: templateData.html || '',
        description: templateData.description || '',
        attachmentIds: Array.isArray(templateData.attachmentIds) ? templateData.attachmentIds : [],
        createdAt: templateData.createdAt || Date.now(),
        updatedAt: templateData.updatedAt || Date.now(),
        folderId: typeof templateData.folderId === 'string' ? templateData.folderId : ''
    };
    if (hasCategory(templateData)) payload.category = templateCategory(templateData);
    return payload;
}

export function buildImportTemplatePayload(template = {}) {
    const payload = {
        name: (template.name || 'Imported Template').trim(),
        subject: template.subject || '',
        html: template.html || '',
        description: template.description || 'Imported template',
        attachmentIds: Array.isArray(template.attachmentIds) ? template.attachmentIds : [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
        folderId: ''
    };
    if (hasCategory(template)) payload.category = templateCategory(template);
    return payload;
}
